import React from 'react';
import { MessageSquareIcon, TargetIcon, RocketIcon, TrendingUpIcon } from 'lucide-react';
const steps = [{
  icon: MessageSquareIcon,
  title: 'Discovery Call',
  description: 'We analyze your business, ICP, and growth goals to create a custom AI-powered strategy',
  duration: 'Week 1'
}, {
  icon: TargetIcon,
  title: 'AI Setup & Training',
  description: 'Our experts configure AI systems, train models on your brand voice, and set up all integrations',
  duration: 'Week 2-3'
}, {
  icon: RocketIcon,
  title: 'Launch & Optimize',
  description: 'We launch campaigns across channels, monitor performance, and continuously optimize with AI',
  duration: 'Week 4+'
}, {
  icon: TrendingUpIcon,
  title: 'Scale & Grow',
  description: 'As results prove out, we scale winning strategies and expand to new channels and markets',
  duration: 'Ongoing'
}];
export function HowItWorks() {
  return <div className="py-24 bg-white" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-138">
            How It Works
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-139">
              Simple, Proven Process
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-140">
            From strategy to execution, we handle everything so you can focus on
            closing deals
          </p>
        </div>
        {/* Steps */}
        <div className="relative" data-id="element-141">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-purple-200 to-blue-200" data-id="element-142"></div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-143">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={index} className="relative" data-id="element-144">
                  {/* Step number */}
                  <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-lg z-10" data-id="element-145">
                    {index + 1}
                  </div>
                  <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border-2 border-blue-100 hover:border-blue-300 transition-all h-full" data-id="element-146">
                    {/* Icon */}
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center mb-4 mx-auto" data-id="element-147">
                      <Icon className="w-8 h-8 text-white" data-id="element-148" />
                    </div>
                    {/* Duration badge */}
                    <div className="inline-block bg-white px-3 py-1 rounded-full text-xs font-semibold text-blue-600 mb-3" data-id="element-149">
                      {step.duration}
                    </div>
                    {/* Title */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-150">
                      {step.title}
                    </h3>
                    {/* Description */}
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-151">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
        {/* Bottom CTA */}
        <div className="mt-16 text-center" data-id="element-152">
          <p className="text-gray-600 mb-4" data-id="element-153">
            Most clients see measurable results within the first 30 days
          </p>
          <button onClick={() => window.open('https://calendly.com', '_blank')} className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold hover:shadow-lg transition-all" data-id="element-154">
            Start Your Journey Today
          </button>
        </div>
      </div>
    </div>;
}